document.querySelectorAll('.actions-results').forEach((root) => {
    const buttons = root.querySelectorAll('.actions-results__button');
    const images = root.querySelectorAll('.actions-results__image');

    const selectTab = (blockId) => {
        const syncState = (element) => element.classList.toggle('is-active', element.dataset.blockId === blockId);

        buttons.forEach(syncState);
        images.forEach(syncState);
    };

    buttons.forEach((button) => {
        button.addEventListener('click', () => selectTab(button.dataset.blockId));
    });
});

document.querySelectorAll('.actions-results__accordions').forEach((group) => {
    group.querySelectorAll('accordion-tab > details').forEach((details) => {
        details.addEventListener('toggle', () => {
            if (!details.open) return;

            group.querySelectorAll('accordion-tab > details[open]').forEach((other) => {
                if (other === details) return;

                const summary = other.querySelector('summary');
                if (summary) summary.click();
            });
        });
    });
});
